import { ImageElement, SurfaceImageMap, TextElementPosition } from '@/types/personalization';

const DEFAULT_POSITION: TextElementPosition = { x: 0.5, y: 0.5 };
const DEFAULT_SCALE = 0.3;

type ImageElementInput = Partial<Omit<ImageElement, 'id' | 'surfaceId' | 'src'>> &
	Pick<ImageElement, 'id' | 'surfaceId' | 'src' | 'naturalWidth' | 'naturalHeight'> & {
		originalName?: string;
	};

export const ensureImageElementDefaults = (element: ImageElementInput): ImageElement => ({
	id: element.id,
	surfaceId: element.surfaceId,
	src: element.src,
	position: element.position ?? DEFAULT_POSITION,
	layerIndex: element.layerIndex ?? -1,
	scale: element.scale ?? DEFAULT_SCALE,
	rotation: element.rotation ?? 0,
	naturalWidth: element.naturalWidth,
	naturalHeight: element.naturalHeight,
	originalName: element.originalName ?? 'grafika',
	repeatGroupId: element.repeatGroupId,
	repeatIndex: element.repeatIndex,
});

export const createImageElement = (
	overrides: Partial<ImageElementInput> &
		Pick<ImageElement, 'surfaceId' | 'src' | 'naturalWidth' | 'naturalHeight'>
): ImageElement => {
	const id = overrides.id ?? globalThis.crypto?.randomUUID?.() ?? `image-${Date.now()}`;
	return ensureImageElementDefaults({
		...overrides,
		id,
	});
};

export const cloneSurfaceImageMap = (map: SurfaceImageMap): SurfaceImageMap =>
	Object.fromEntries(
		Object.entries(map).map(([surfaceId, elements]) => [
			surfaceId,
			elements.map((element, index) =>
				ensureImageElementDefaults({
					...element,
					layerIndex: element.layerIndex ?? index,
				})
			),
		])
	);
